import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration } from 'actions/Site'
import { fetchAboutDplk, deleteAboutDplk } from 'actions/AboutDplk'
import AboutDplkView from 'components/pages/aboutDplk/List'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'

export function mapStateToProps(state) {
  const {
    isFetching,
    dataAboutDplk,
    metaAboutDplk,
  } = state.root.aboutDplk
  const { currentUser } = state.root.auth

  return {
    isFetching,
    dataAboutDplk,
    metaAboutDplk,
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  fetchAboutDplk: bindActionCreators(fetchAboutDplk, dispatch),
  deleteAboutDplk: bindActionCreators(deleteAboutDplk, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('stateSearch', 'setStateSearch', {}),
  withHandlers({
    onLoad: props => (isSearch) => {
      const { page, search } = props.stateSearch
      const payload = {
        page: isSearch ? '' : page,
        search: search || '',
      }

      props.fetchAboutDplk(`?${qs.stringify(pickBy(payload, identity))}`)
    },
  }),

  withHandlers({
    handleSearch: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        search: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handlePage: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        page: val,
      })
      setTimeout(() => {
        onLoad()
      }, 300)
    },
    handleDelete: props => (id) => {
      props.deleteAboutDplk(id)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'DPLK Anda'])
      this.props.updateSiteConfiguration('titlePage', 'DPLK Anda')
      this.props.fetchAboutDplk()
    },
  }),
)(AboutDplkView)
